import { RTKQueryTag } from 'src/common/constants';
import type { ApiResponse } from 'src/common/interfaces';
import { apiSlice } from 'src/features/api/api-slice';

export const extendedApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    updateExperience: builder.mutation<ApiResponse, { experience: string }>({
      query: (experience) => ({
        method: 'PATCH',
        url: '/users/experience',
        body: experience,
      }),
      invalidatesTags: [RTKQueryTag.User],
    }),
  }),
});

export const { useUpdateExperienceMutation } = extendedApiSlice;
